import { Start, Stop } from 'smg/buttons';
import { CreateContact } from 'smg/customer-api/contact';
import { Session } from 'smg/customer-api/session';
import { HandleRequestError } from 'smg/errors';
import { ReportValidity } from 'smg/form';
import Modal from 'smg/modal';
import * as phone from 'smg/phone';
import * as template from 'smg/template';
import { FullName } from 'smg/users';
import * as uploads from './components/uploader';
import i18n from './i18n';

export function ContactForm($form: HTMLFormElement, $formTemplate: HTMLTemplateElement, prefix: string = 'contact-form-'): void {
    const $fieldset = $form.querySelector('fieldset') as HTMLFieldSetElement;

    let submit: () => Promise<void>;

    const initMainForm = () => {
        $fieldset.appendChild(template.Clone($formTemplate).firstElementChild as HTMLElement);
        submit = InitForm($form, prefix);
    };
    initMainForm();

    $form.noValidate = true;
    $form.addEventListener('submit', e => {
        e.preventDefault();

        if (!ReportValidity($form)) {
            return;
        }

        $fieldset.disabled = true;

        submit().
            then(() => {
                $fieldset.innerHTML = '';
                initMainForm();
            }).
            catch(HandleRequestError).
            finally(() => $fieldset.disabled = false);
    });
}

export function InitForm($parent: HTMLElement, prefix: string): () => Promise<void> {
    const $reason = $parent.querySelector(`#${prefix}reason`) as HTMLSelectElement;
    const $notes = $parent.querySelector(`#${prefix}comments`) as HTMLTextAreaElement;

    const $submit = $parent.querySelector(`#${prefix}submit`) as HTMLButtonElement;

    const $attachments = $parent.querySelector(`#${prefix}attachments`) as HTMLInputElement;
    const $attachmentsLabel = $attachments.closest('.uploader-dropzone') as HTMLLabelElement;
    const attachments = new uploads.Uploader($attachmentsLabel, {
        confirmBtn: $submit,
    });

    const $fullName = $parent.querySelector(`#${prefix}full-name`) as HTMLInputElement;
    const $org = $parent.querySelector(`#${prefix}org`) as HTMLInputElement;
    const $email = $parent.querySelector(`#${prefix}email`) as HTMLInputElement;

    const $phone = $parent.querySelector(`#${prefix}phone`) as HTMLInputElement;
    const p = new phone.Phone($phone);

    void Session().then(sess => {
        $fullName.value = FullName(sess);
        $email.value = sess.email;
        void p.Iti.promise.then(() =>
            p.Iti.setNumber(sess.phone));
    }).catch(() => undefined);

    const $methodText = $parent.querySelector(`#${prefix}method-text`) as HTMLInputElement;

    const $methods = Array.from($parent.querySelectorAll(`input[name="${prefix}method"]`) as NodeListOf<HTMLInputElement>);

    const $reCaptchaPlaceholder = $parent.querySelector(`#${prefix}recaptcha`) as HTMLElement;

    const $successTemplate = document.querySelector('#contact-form-success-template') as HTMLTemplateElement;

    return () => {
        Start($submit);

        return CreateContact({
            name: $fullName.value,
            company: $org.value,
            content: `${i18n('contactFormReasonSelected')} ${$reason.value}\n${i18n('contactFormPreferredContactMethod')} ${$methods.find($m => $m.checked)?.value || ''}\n\n${$notes.value}`,
            email: $email.value,
            phone: p,
            uploader: attachments,
            preferSMS: $methodText.checked,
            $reCaptchaPlaceholder,
        }).then(() => {
            const $body = template.Clone($successTemplate).firstElementChild as HTMLElement;

            new Modal({
                width: '38.5rem',
                body: $body,
                confirmText: i18n('contactNoteSentClose'),
                appendConfirmButtonClass: 'w-100 w-sm-auto btn-sm-lg',
                cancelButton: false,
                appendClassBySelector: {
                    '.modal-dialog': 'px-4 px-6',
                    '.modal-body': 'px-6 pt-8 pb-2',
                    '.modal-footer': 'p-6 pt-sm-10 pb-sm-14 justify-content-center',
                },
            });
        }).finally(() => {
            Stop($submit);
        });
    };
}
